import type { App } from 'vue';

const UnleashFeature = {
    name: 'UnleashFeature',
    props: {
        name: {
            type: String,
            required: true,
        },
    },
    computed: {
        isEnabled(this: any): boolean {
            const enabledFeatures = this.$store?.state?.unleash?.enabledFeatures || {};
            if (!(this.name in enabledFeatures)) {
                return true;
            }
            return Boolean(enabledFeatures[this.name]);
        },
    },
    render(this: any) {
        if (!this.isEnabled) {
            return null;
        }

        const slot = this.$slots.default;
        return slot ? slot({})[0] || null : null;
    },
};

export default {
    install(app: App, options: any = {}) {
        const { store } = options as { store?: any };

        if (store && !store.hasModule('unleash')) {
            store.registerModule('unleash', {
                namespaced: true,
                state: () => ({
                    enabledFeatures: {},
                }),
                mutations: {
                    setFeatures(state: any, features: Record<string, boolean>) {
                        state.enabledFeatures = { ...features };
                    },
                },
            });
        }

        app.component('UnleashFeature', UnleashFeature);
    },
};
